import { render } from "./DirectoryList.vue?vue&type=template&id=fe4b4002&scoped=true"
import script from "./DirectoryList.vue?vue&type=script&lang=js"
export * from "./DirectoryList.vue?vue&type=script&lang=js"

import "./DirectoryList.vue?vue&type=style&index=0&id=fe4b4002&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src76281229/src/git-codecommit.us-east-1.amazonaws.com/v1/repos/www-uga-edu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4b4002"]])

export default __exports__